import React from 'react';
import { getEntityStatement, sendStatement } from '../reducers/entities';
import { getInvoice, selectInvoice } from '../reducers/invoices';
import { connect } from "react-redux";
import moment from "moment";
import DownloadLink from "react-download-link";
import urls from '../network/urls';
import { format } from '../helpers/invoiceNumber';
import Invoice from '../components/invoice';
import {
    MDBDataTable,
} from 'mdbreact';

const StatementComponent = ({ entityStatement,
    entity,
    authUser,
    selectedCompanyId,
    dispatchSendStatement,
    dispatchGetEntityStatement,
    dispatchGetInvoice,
    dispatchSelectInvoice }) => {

    const [filterDateFrom, setFilterDateFrom] = React.useState(moment().subtract(6, 'months').format('YYYY-MM-DD'));
    const [filterDateTo, setFilterDateTo] = React.useState(moment().format('YYYY-MM-DD'));
    const [showInvoice, setShowInvoice] = React.useState(false);

    const openInvoice = (invoiceId) => {
        dispatchSelectInvoice(invoiceId);
        dispatchGetInvoice(invoiceId, (error) => {
            if (!error) setShowInvoice(true);
        });
    };

    // Re-fetch statement when date filter changes
    React.useEffect(() => {
        if (entity && entity._id) {
            console.log('Statement filter - From:', filterDateFrom, 'To:', filterDateTo);
            dispatchGetEntityStatement(entity._id, filterDateFrom || undefined, filterDateTo || undefined);
        }
    }, [filterDateFrom, filterDateTo, entity?._id]);

    const getDataFromURL = (url, user) => new Promise((resolve, reject) => {
        setTimeout(() => {
            let req = {
                headers: {
                    username: user.username,
                    token: user.token,
                    AUTHORIZATION: user.token
                },
                method: 'GET'
            }

            fetch(url, req)
                .then(response => response.blob())
                .then(data => {
                    resolve(data)
                });
        });
    }, 2000);

    var appointments = [];

    if (entityStatement && entityStatement.lineItems && entityStatement.lineItems.length > 0) {
        // Server handles filtering now, just map the data
        appointments = entityStatement.lineItems.map(p => {
            const dateFormatted = p.invoiceDate && moment(p.invoiceDate).isValid()
                ? moment(p.invoiceDate).format('YYYY-MM-DD')
                : '-';
            const descText = p.invoiceNumber + ' ' + (p.description ?? '');
            return {
                date: dateFormatted,
                description: p.invoiceId
                    ? <span onClick={() => openInvoice(p.invoiceId)} style={{ color: '#19a6b7', cursor: 'pointer', textDecoration: 'underline' }}>{descText}</span>
                    : descText,
                rolling: p.rolling,
                total: p.total + ' ' + p.debit_credit,
                invoiceId: p.invoiceId
            }
        });
    }

    const data = {
        columns: [
            {
                label: 'Invoice Date',
                field: 'date',
                sort: 'asc'
            },
            {
                label: 'Description',
                field: 'description',
                sort: 'asc'
            },
            {
                label: 'Amount',
                field: 'total',
                sort: 'asc'
            },
            {
                label: 'Total',
                field: 'rolling',
                sort: 'asc'
            }
        ],
        rows: appointments
    };

    if (showInvoice) {
        return (
            <div style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                padding: 20,
                paddingBottom: 60,
                position: 'relative',
                height: 'calc(100vh - 120px)',
                maxHeight: 'calc(100vh - 120px)'
            }}>
                <Invoice showAdd={showInvoice} updateshowAdd={setShowInvoice} />
            </div>
        );
    }

    return (
        <div>
            <h5>Total Balance: {entityStatement && 'R ' + format(entityStatement.total)}</h5>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                {entity && entity._id && <DownloadLink
                    label="Download"
                    className="btn btn-primary"
                    style={{ margin: 0, textDecoration: 'none', color: 'white', cursor: 'pointer' }}
                    filename={entity.name.replace(' ', '_') + '_statement' + '_' + ".pdf"}
                    exportFile={() => {
                        let downloadUrl = urls.getEntities(selectedCompanyId) + '/' + entity._id + '/download';
                        const params = [];
                        if (filterDateFrom) params.push('from=' + filterDateFrom);
                        if (filterDateTo) params.push('to=' + filterDateTo);
                        if (params.length > 0) downloadUrl += '?' + params.join('&');
                        console.log('Download URL:', downloadUrl);
                        return Promise.resolve(getDataFromURL(downloadUrl, authUser));
                    }}
                ></DownloadLink>}
                <button className="btn btn-info btn-sm" type="button" onClick={() => dispatchSendStatement(entity._id)} style={{ fontSize: 16, padding: 6 }}>Send Statement</button>
            </div>

            {/* Date Filter */}
            <div style={{
                display: 'flex',
                gap: 12,
                marginBottom: 16,
                alignItems: 'center',
                flexWrap: 'wrap'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <label style={{ fontSize: 13, color: '#666', fontWeight: 500 }}>From:</label>
                    <input
                        type="date"
                        value={filterDateFrom}
                        onChange={(e) => setFilterDateFrom(e.target.value)}
                        style={{
                            padding: '8px 12px',
                            border: '1px solid #ddd',
                            borderRadius: 6,
                            fontSize: 13,
                            color: '#333'
                        }}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <label style={{ fontSize: 13, color: '#666', fontWeight: 500 }}>To:</label>
                    <input
                        type="date"
                        value={filterDateTo}
                        onChange={(e) => setFilterDateTo(e.target.value)}
                        style={{
                            padding: '8px 12px',
                            border: '1px solid #ddd',
                            borderRadius: 6,
                            fontSize: 13,
                            color: '#333'
                        }}
                    />
                </div>
                {(filterDateFrom || filterDateTo) && (
                    <button
                        type="button"
                        onClick={() => {
                            setFilterDateFrom("");
                            setFilterDateTo("");
                        }}
                        style={{
                            background: '#f5f5f5',
                            border: '1px solid #ddd',
                            color: '#666',
                            padding: '8px 12px',
                            borderRadius: 6,
                            cursor: 'pointer',
                            fontSize: 13,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4
                        }}
                    >
                        <i className="fas fa-times"></i> Clear
                    </button>
                )}
                {(filterDateFrom || filterDateTo) && appointments.length > 0 && (
                    <span style={{ fontSize: 12, color: '#888' }}>
                        Showing {appointments.length} items
                    </span>
                )}
            </div>

            <MDBDataTable
                striped
                bordered
                paging={false}
                small
                data={data}
            />

        </div>
    )
};

class StatementComponentScreen extends React.Component {

    state = {
    }

    render() {
        return (
            <StatementComponent
                {...this.props} />
        );
    }
}

const mapStateToProps = state => ({
    entityStatement: state.entities.entityStatement,
    loading: state.entities.loading,
    selectedCompanyId: state.companies.selectedCompanyId,
    authUser: state.auth.user,
    entity: state.entities.entity
})

const mapDispatchToProps = {
    dispatchGetEntityStatement: (id, startDate, endDate) => getEntityStatement(id, startDate, endDate),
    dispatchSendStatement: (id) => sendStatement(id),
    dispatchGetInvoice: (id, callback) => getInvoice(id, callback),
    dispatchSelectInvoice: (id) => selectInvoice(id)
}

export default connect(mapStateToProps, mapDispatchToProps)(StatementComponentScreen)
